import React from 'react';

export default function ChapterBox({ chapterNo, chapterName }) {
  return (
    <>
  
  <div className="relative bg-white rounded-tl-lg rounded-br-lg rounded-bl-lg p-4 w-72 border-2 border-transparent hover:border-red-900 ml-4 mr-2 mb-3 shadow-md hover:shadow-xl transition-all duration-300 group">
      
      {/* Eye icon in the middle top */}
      <div className="absolute top-0 -right-5 transform -translate-x-1/2">
        <button className="h-10 w-10 bg-slate-500 rounded-bl-full  flex items-center justify-center text-black group-hover:bg-blue-800 group-hover:text-white transition-colors duration-300">
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 576 512"
            height="16"
            width="16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"></path>
          </svg>
        </button>
      </div>

      {/* Chapter content */}
      <div className="flex flex-col mt-0 ml- items-center text-center">
        <div className="text-blue-700 font-bold ">Chapter {chapterNo}</div>
        <div className="mt-1 text-black-800 font-normal text-lg">{chapterName}</div>
      </div>
    </div>
    </>
  );
}
